import React            from 'react';
import StandaloneButton from '../components/standalone_button';


export default function BookerStatus({ status, onDisconnect, onConnect }) {
  switch (status) {
    case null:
    case undefined:
    case 404:
      return <Connect onConnect={onConnect}/>;
    case 200:
      return <Connected onDisconnect={onDisconnect}/>;
    default:
      return <Error onConnect={onConnect}/>;
  }
}


export function Connect({ onConnect }) {
  return (
    <div className="list">
      <p className="block inset">
        Once you add Booker, customers with completed appointments will appear
        in the Broadly App as new customers. We will follow up with those
        customers using the preferences set in Booker.
      </p>
      <StandaloneButton
        label="Add Booker"
        onClick={onConnect}
        className="datasource-button"/>
    </div>
  );
}


export function Connected({ onDisconnect }) {
  return (
    <div className="list">
      <p className="block inset">
        Booker is working as expected and sending us data.
      </p>
      <StandaloneButton
        label="Stop Using Booker"
        onClick={onDisconnect}
        className="datasource-button"
        danger/>
    </div>
  );
}


export function Error({ onConnect }) {
  return (
    <div className="list">
      <p className="block inset">
        Something is wrong with your Booker data source.
        Usually this is resolved by connecting it again.
      </p>
      <StandaloneButton
        label="Add Booker"
        onClick={onConnect}
        className="datasource-button"/>
    </div>
  );
}
